import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import styles from "./CharacterCountCircle.module.scss";
import { useRemSize } from "../../../../hooks/useRemSize";
interface CharacterCountCircleProps {
  count: number;
  max: number;
}
const CharacterCountCircle: React.FC<CharacterCountCircleProps> = t0 => {
  const $ = _c(33);
  const {
    count,
    max
  } = t0;
  const remInPixels = useRemSize();
  const size = Math.round(remInPixels);
  let t1;
  if ($[0] !== size) {
    t1 = Math.round(size / 7);
    $[0] = size;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const stroke = Math.max(1.5, t1);
  const rad = size / 2 - stroke / 2;
  const circ = 2 * Math.PI * rad;
  let t2;
  if ($[2] !== circ || $[3] !== rad || $[4] !== size || $[5] !== stroke) {
    t2 = {
      SVG_SIZE: size,
      STROKE_WIDTH: stroke,
      radius: rad,
      circumference: circ
    };
    $[2] = circ;
    $[3] = rad;
    $[4] = size;
    $[5] = stroke;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    SVG_SIZE,
    STROKE_WIDTH,
    radius,
    circumference
  } = t2;
  const clampedCount = Math.min(count, max);
  const percentage = max > 0 ? clampedCount / max * 100 : 0;
  const offset = circumference - percentage / 100 * circumference;
  let strokeColorClass = styles.normal;
  if (percentage >= 100) {
    strokeColorClass = styles.warning;
  } else {
    if (percentage >= 90) {
      strokeColorClass = styles.warning;
    }
  }
  const safeOffset = Math.max(0, offset);
  const t3 = `${clampedCount}/${max}`;
  let t4;
  if ($[7] !== t3) {
    t4 = <span className={styles.countText}>{t3}</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `0 0 ${SVG_SIZE} ${SVG_SIZE}`;
  let t6;
  if ($[9] !== percentage) {
    t6 = percentage.toFixed(0);
    $[9] = percentage;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = `Character count progress: ${t6}%`;
  const t8 = SVG_SIZE / 2;
  const t9 = SVG_SIZE / 2;
  let t10;
  if ($[11] !== STROKE_WIDTH || $[12] !== radius || $[13] !== t8 || $[14] !== t9) {
    t10 = <circle className={styles.backgroundCircle} strokeWidth={STROKE_WIDTH} fill="transparent" r={radius} cx={t8} cy={t9} />;
    $[11] = STROKE_WIDTH;
    $[12] = radius;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = `${styles.progressCircle} ${strokeColorClass}`;
  const t12 = SVG_SIZE / 2;
  const t13 = SVG_SIZE / 2;
  let t14;
  if ($[16] !== STROKE_WIDTH || $[17] !== circumference || $[18] !== radius || $[19] !== safeOffset || $[20] !== t11 || $[21] !== t12 || $[22] !== t13) {
    t14 = <circle className={t11} strokeWidth={STROKE_WIDTH} strokeDasharray={circumference} strokeDashoffset={safeOffset} strokeLinecap="round" fill="transparent" r={radius} cx={t12} cy={t13} />;
    $[16] = STROKE_WIDTH;
    $[17] = circumference;
    $[18] = radius;
    $[19] = safeOffset;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== SVG_SIZE || $[25] !== t10 || $[26] !== t14 || $[27] !== t5 || $[28] !== t7) {
    t15 = <svg width={SVG_SIZE} height={SVG_SIZE} viewBox={t5} className={styles.circleSvg} role="img" aria-label={t7}>{t10}{t14}</svg>;
    $[24] = SVG_SIZE;
    $[25] = t10;
    $[26] = t14;
    $[27] = t5;
    $[28] = t7;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15 || $[31] !== t4) {
    t16 = <div className={styles.characterCountContainer} aria-live="polite" aria-atomic="true">{t4}{t15}</div>;
    $[30] = t15;
    $[31] = t4;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
};
export default CharacterCountCircle;